import { storyblokEditable } from '@storyblok/react/rsc'
import Image from 'next/image'
import { type FC } from 'react'

import { storyblokImageLoader } from '../../config'
import { type StoryblokComponentProps } from '../../model'
import { type StoryblokImageType } from '../../model/storyblokTypes.generated'

export const StoryblokImage: FC<
  StoryblokComponentProps<StoryblokImageType>
> = ({ blok }) => {
  return (
    blok.asset.filename && (
      <Image
        {...storyblokEditable(blok)}
        alt={blok.asset.alt ?? ''}
        height={Number(blok.height)}
        loader={storyblokImageLoader}
        src={blok.asset.filename}
        width={Number(blok.width)}
      />
    )
  )
}
